import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import PrimaryButton from '../../components/common/PrimaryButton';
import FloatingView from '../../components/common/FloatingView';

const nurturixLogo = process.env.PUBLIC_URL + '/assets/images/logo.png';
const pulseWebLogo = process.env.PUBLIC_URL + '/assets/images/pulsewebstudio.png';

const products = [
  {
    key: 'nurturix',
    name: 'Nurturix',
    logo: nurturixLogo,
    productID: 'nurturix',
    tagline: 'Marketing Automation & Lead Management',
    plans: [
      {
        name: 'Basics',
        price: '1099 INR',
        term: 'per month + tax (6 months term, paid upfront)',
        features: [
          'Use 20+ available templates to create campaign.',
          'Track and manage your leads.',
          'Easy follow up with your leads using WhatsApp and email.',
          'Get automated emails as reminder to follow up with leads.'
        ]
      },
      {
        name: 'Premium',
        price: '899 INR',
        term: 'per month + tax (13 months term, paid upfront)',
        features: [
          'Use 20+ available templates to create campaign.',
          'Track and manage your leads.',
          'Easy follow up with your leads using WhatsApp and email.',
          'Get automated emails as reminder to follow up with leads.'
        ]
      },
      {
        name: 'Ultra Premium (AI)',
        price: '1399 INR',
        term: 'per month + tax (13 months term, paid upfront)',
        features: [
          'Everything in premium plan',
          'Use automation to submit your ads on social media.',
          'Create fully customized campaign.',
          'Generate campaign images using AI (limit 10 images per month).'
        ]
      }
    ]
  },
  {
    key: 'pulseweb',
    name: 'PulseWeb Studio',
    productID: 'webDesign',
    logo: pulseWebLogo,
    tagline: 'Professional Website Design & Development',
    plans: [
      {
        name: 'PulseWeb Studio',
        price: '6000 INR',
        term: 'per year (includes 1 year support)',
        features: [
          'Professional Website',
          '1 Year Support SSL',
          'SSL',
          'Mobile Friendly',
          'Only ₹6000/year',
          'Free Consultation'
        ],
        cta: {
          label: "Let's Build Your Website!",
          sublabel: 'Get Started',
          info: '*All-inclusive. No hidden fees. Limited-time offer. Contact us: support@Prospectpulse.in'
        }
      }
    ]
  }
];

const Products = () => {
  const [selected, setSelected] = useState(products[0].key);
  const selectedProduct = products.find(p => p.key === selected);

  return (
    <div className="py-5">
      <Container>
        {/* Product Tiles */}
        <Row className="mb-4 justify-content-center gap-3">
          {products.map(product => (
            <Col key={product.key} xs={10} sm={5} md={4} lg={3} className="mb-3">
              <Card
                className={`h-100 shadow-sm text-center product-tile ${selected === product.key ? 'border-primary border-3' : 'border-light'} clickable`}
                style={{ cursor: 'pointer', transition: 'box-shadow 0.2s' }}
                onClick={() => setSelected(product.key)}
              >
                <Card.Body>
                  <img src={product.logo} alt={product.name + ' Logo'} style={{ maxHeight: '60px', width: 'auto', marginBottom: 12 }} />
                  <h5 className="fw-bold mb-1">{product.name}</h5>
                  <div className="text-muted small mb-2">{product.tagline}</div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Divider */}
        <div style={{ borderTop: '2px solid #eee', margin: '32px 0' }} />

        {/* Pricing/Details Section */}
        <Row className="justify-content-center">
          {selectedProduct.plans.map((plan, idx) => (
            <Col md={selectedProduct.plans.length > 1 ? 4 : 8} className="mb-4" key={plan.name}>
              <Card className="h-100 border-0 shadow-sm text-center d-flex flex-column">
                <Card.Body className="p-4 d-flex flex-column">
                  <div className="flex-grow-1">
                    <FloatingView className="mb-3">{plan.name}</FloatingView>
                    <div className="mb-2 text-muted">{plan.term}</div>
                    <div className="mb-2 fw-bold">Cost: {plan.price}</div>
                    <div className="fw-bold mb-2">What's included.</div>
                    <ul className="text-start mb-4">
                      {plan.features.map((f, i) => (
                        <li key={i} className="mb-2">✔ {f}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="mt-auto">
                    {selectedProduct.productID === 'webDesign' ? (
                       <PrimaryButton className="w-50">Subscribe</PrimaryButton>
                     ) : (
                       <PrimaryButton className="w-100">Activate</PrimaryButton>
                     )}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Products; 